import { Message } from 'components/message'
import moment from "moment";

export class ListagemPedidoObserver {

  constructor(numeroPedido) {
    this.numeroPedido = numeroPedido
  }

  next(res) {
    if (res.data != null) {
        let inputData = document.getElementById('previsao-entrega-data-' + this.numeroPedido)
        let inputHora = document.getElementById('previsao-entrega-hora-' + this.numeroPedido)

        let dia = moment(res.data).format("DD/MM");
        let hora = moment(res.data).format("HH:mm");

        if (dia != null && dia != '' && dia != 'undefined' && inputData != null) {
          inputData.textContent = dia
        }
        if (hora != null && hora != '' && hora != 'undefined' && inputHora != null) {
          inputHora.textContent = hora
        }
    }
  }

  error(error) {
  }

  complete() {
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/pages/minha-conta/pedido/listagem-pedido.observer.js